import { render, staticRenderFns } from "./AddGaofang.vue?vue&type=template&id=7506512f&scoped=true"
import script from "./AddGaofang.vue?vue&type=script&lang=js"
export * from "./AddGaofang.vue?vue&type=script&lang=js"
import style0 from "./AddGaofang.vue?vue&type=style&index=0&id=7506512f&prod&lang=scss&scoped=true"
import style1 from "./AddGaofang.vue?vue&type=style&index=1&id=7506512f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7506512f",
  null
  
)

export default component.exports